<template>
  <div id="patient_form" :style="action=='Delete'?'min-height: 320px':'min-height: 400px'">
    <div class="vx-row">
      <div v-if="action==='Update'" class="vx-col w-1/4 mt-2 mb-2 flex">
        <vx-card title="Detail Order">
           <vs-row class="mt-2">
             <vs-col class="w-full flex" vs-justify="center" vs-align="center">
               <vs-select
                 autocomplete
                 class="w-full"
                 name="priority"
                 placeholder="Pilih Prioritas"
                 v-model="priority"
                 label="Prioritas"
                 disabled
                 >
                 <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listPriority" />
               </vs-select>
             </vs-col>
           </vs-row>
           <vs-row class="mt-2">
             <vs-col class="w-full flex" vs-justify="center" vs-align="center">
               <vs-select
                  autocomplete
                  class="w-full"
                  name="visitType"
                  placeholder="Pilih Tipe Kunjungan"
                  v-model="visitType"
                  label="Tipe Kunjungan"
                  disabled
                  >
                  <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listVisitType" />
                </vs-select>
              </vs-col>
            </vs-row>
            <vs-row class="mt-2">
              <vs-col class="w-full flex" vs-justify="center" vs-align="center">
                <!--vs-select
                   autocomplete
                   class="w-full"
                   name="ward"
                   placeholder="Pilih Ruangan"
                   v-model="ward"
                   label="Ruangan"
                   >
                   <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listWard" />
                 </vs-select-->
                 <vs-input name="ward" label="Ruangan" class="w-full" v-model="ward" disabled/>
               </vs-col>
             </vs-row>
             <vs-row class="mt-2">
               <vs-col class="w-full flex" vs-justify="center" vs-align="center">
                 <vs-select
                    autocomplete
                    class="w-full"
                    name="insurer"
                    placeholder="Pilih Penjamin"
                    v-model="insurer"
                    label="Penjamin"
                    disabled
                    >
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listInsurer" />
                  </vs-select>
              </vs-col>

             <vs-col class="w-full">
                 <span
                     class="text-danger text-sm w-1/2"
                     v-show="ward == '' && validate"
                     >Ruangan harus diisi</span>
             </vs-col>
           </vs-row>
           <vs-row class="mt-2">
             <vs-col class="w-full flex" vs-justify="center" vs-align="center">
                <vs-select
                   autocomplete
                   class="w-full"
                   name="physician"
                   placeholder="Pilih DPJP"
                   v-model="physician"
                   label="Dokter DPJP"
                   disabled
                   >
                   <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listPhysicians" />
                 </vs-select>
               </vs-col>
           </vs-row>
        </vx-card>
      </div>
      <div v-else class="vx-col w-1/2 mt-2 mb-2 flex">
        <vx-card title="Detail Order">
           <vs-row class="mt-4">
             <vs-col class="w-full flex" vs-justify="center" vs-align="center">
               <vs-select
                 autocomplete
                 class="w-1/2"
                 name="priority"
                 placeholder="Pilih Prioritas"
                 v-model="priority"
                 label="Prioritas"
                 disabled
                 >
                 <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listPriority" />
               </vs-select>

               <vs-select
                  autocomplete
                  class="w-1/2 ml-4"
                  name="visitType"
                  placeholder="Pilih Tipe Kunjungan"
                  v-model="visitType"
                  label="Tipe Kunjungan"
                  disabled
                  >
                  <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listVisitType" />
                </vs-select>
              </vs-col>
           </vs-row>
           <vs-row class="mt-4">
             <vs-col class="w-full flex" vs-justify="center" vs-align="center">
                <!--vs-select
                   autocomplete
                   class="w-1/2"
                   name="ward"
                   placeholder="Pilih Ruangan"
                   v-model="ward"
                   label="Ruangan"
                   >
                   <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listWard" />
                 </vs-select-->
                 <vs-input name="ward" label="Ruangan" class="w-1/2" v-model="ward" disabled/>

                 <vs-select
                    autocomplete
                    class="w-1/2 ml-4"
                    name="insurer"
                    placeholder="Pilih Penjamin"
                    v-model="insurer"
                    label="Penjamin"
                    disabled
                    >
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listInsurer" />
                  </vs-select>
              </vs-col>
           </vs-row>
           <vs-row>
             <vs-col class="w-full">
                 <span
                     class="text-danger text-sm w-1/2"
                     v-show="ward == '' && validate"
                     >Ruangan harus diisi</span>
              </vs-col>
           </vs-row>
           <vs-row class="mt-4">
              <vs-col class="w-full flex" vs-justify="center" vs-align="center">
                <vs-select
                   autocomplete
                   class="w-1/2 ml-4"
                   name="physician"
                   placeholder="Pilih DPJP"
                   v-model="physician"
                   label="Dokter DPJP"
                   disabled
                   >
                   <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listPhysicians" />
                 </vs-select>
               </vs-col>
           </vs-row>
        </vx-card>
      </div>
      <div :class="action==='Update'?'vx-col w-3/4 flex':'vx-col w-1/2  flex'">
       <div :class="action==='Update'?'vx-col w-1/2 mt-2 mb-2 mr-2 flex':'vx-col w-full mt-2 mb-2 mr-2 flex'">
         <vx-card title="Test / Pemeriksaan">
           <div class="vx-row">
             <div class="vx-col w-full mt-2 mb-2"  v-if="from==='QueueClinic' || from==='QueuePCR'">
              <vs-table stripe :data="listTestPatient" noDataText="Tidak Ada Data" style="text-align:center; max-height:320px; overflow:auto">
                  <template slot="thead">
                      <vs-th>No</vs-th>
                      <vs-th>Test/Pemeriksaan</vs-th>
                      <vs-th v-if="action==='Update'">&nbsp;</vs-th>
                  </template>
                  <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td>
                              {{indextr+1}}
                          </vs-td>
                          <vs-td style="width:80%">
                              {{(data[indextr]?data[indextr].parameterName:'')}}
                          </vs-td>
                          <vs-td v-if="action==='Update' || action==='Delete'">
                              <vs-button radius style="cursor: pointer;" @click="openConfirm(indextr)" color="danger" icon="delete"></vs-button>
                          </vs-td>
                      </vs-tr>
                  </template>
              </vs-table>
             </div>

             <div class="vx-col w-full mt-2 mb-2"  v-if="from==='WorklistClinic' || from==='WorklistPCR'">
              <vs-table stripe :data="listTestPatient" noDataText="Tidak Ada Data" style="text-align:center; max-height:320px; overflow:auto">
                  <template slot="thead">
                      <vs-th>No</vs-th>
                      <vs-th>Test/Pemeriksaan</vs-th>
                      <vs-th v-if="action==='Delete' || action==='Update'">&nbsp;</vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <tbody :key="indextr" v-for="(tr, indextr) in data">
                      <vs-tr :data="tr" style="background-color:#a5e5e5" v-if="tr.test.length>0 || (tr.chidlGroup!=null && tr.chidlGroup[0].test.length>0)">
                          <vs-td colspan="2"><b>{{tr.name}}</b></vs-td>
                          <vs-td v-if="action==='Delete' || action==='Update'">&nbsp;</vs-td>
                      </vs-tr>
                      <vs-tr :key="indextr1" v-for="(tr1, indextr1) in tr.test" v-if="tr1.result===null || action==='Update'">
                          <vs-td>{{indextr1+1}}</vs-td>
                          <vs-td style="text-align: left">{{tr1.name}}</vs-td>
                          <vs-td v-if="action==='Delete' || action==='Update'">
                              <vs-button radius style="cursor: pointer;" @click="openConfirm(indextr, tr.name, tr1.id)" color="danger" icon="delete"></vs-button>
                          </vs-td>
                      </vs-tr>
                      <vs-tr v-if="tr.chidlGroup!=null && tr.chidlGroup[0].test.length>0">
                          <vs-td>{{tr.test.length+1}}</vs-td>
                          <vs-td style="text-align: left">{{tr.chidlGroup[0].name}}</vs-td>
                          <vs-td v-if="action==='Delete' || action==='Update'">&nbsp;</vs-td>
                      </vs-tr>
                      <vs-tr v-for="(tr3, indextr3) in (tr.chidlGroup!==null?tr.chidlGroup[0].test:[])" v-if="tr3.result===null">
                          <vs-td>&nbsp;</vs-td>
                          <vs-td style="text-align: left"><label class="mr-6">o</label> {{tr3.name}}</vs-td>
                          <vs-td v-if="(action==='Delete' && tr.chidlGroup[0].result===null) || action==='Update'">
                              <vs-button radius style="cursor: pointer;" @click="openConfirm2(indextr3, tr.name, tr.chidlGroup[0].name, tr3.id)" color="danger" icon="delete"></vs-button>
                          </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
              </vs-table>
             </div>
           </div>
         </vx-card>
       </div>
       <div v-if="action==='Update'" class="vx-col w-1/2 mt-2 mb-2 flex">
         <vx-card title="Test / Pemeriksaan Tambahan">
           <div class="vx-row">
             <div class="vx-col w-full mt-2 mb-2 flex">
               <vs-select
                 autocomplete
                 class="w-full"
                 name="test"
                 placeholder="Cari Test/Pemeriksaan (Paket)"
                 v-model="test"
                 >
                 <vs-select-item :key="index" :value="item.parameter" :text="item.parameterName" v-for="(item,index) in listTest" />
               </vs-select>
             </div>
           </div>
           <div class="vx-row">
             <div class="vx-col w-full mt-2 mb-2">
              <vs-table stripe :data="listTestAdd" noDataText="Tidak Ada Data" style="text-align:center; max-height:320px; overflow:auto">
                  <template slot="thead">
                      <vs-th>No</vs-th>
                      <vs-th>Test/Pemeriksaan</vs-th>
                      <vs-th>&nbsp;</vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <tbody :key="indextr" v-for="(tr, indextr) in data">
                      <vs-tr :data="tr" :style="(indextr%2==0?'background: transparent!important;':'')">
                          <vs-td>{{indextr+1}}</vs-td>
                          <vs-td style="text-align: left">{{tr.parameterName}}</vs-td>
                          <vs-td>
                              <vs-button radius style="cursor: pointer;" @click="openConfirm1(indextr)" color="danger" icon="delete"></vs-button>
                          </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
              </vs-table>
             </div>
           </div>
         </vx-card>
       </div>
     </div>

    </div>
    <!--div class="vx-row" v-if="action!=='Send' && action!=='Delete'">
      <div :class="(from==='WorklistPCR'?'vx-col w-1/3 mt-2 mb-2 flex':'vx-col w-1/2 mt-2 mb-2 flex')">
        <vx-card title="Instrument">
           <vs-row class="mt-4">
             <vs-col class="w-1/2 mb-4" vs-justify="center" vs-align="center" v-for="instrx in instr">
               <vs-checkbox v-model="instrx.status" :disabled="action!=='Start'">{{instrx.name}}</vs-checkbox>
             </vs-col>
           </vs-row>
        </vx-card>
      </div>
      <div v-if="from==='WorklistPCR'" class="vx-col w-1/3 mt-2 mb-2 flex">
        <vx-card title="Produk Reagen Gen Target">
           <vs-row class="mt-4">
             <vs-col class="w-full flex" vs-justify="center" vs-align="center">
               <vs-select
                 autocomplete
                 class="w-full"
                 name="reagenProduct"
                 placeholder="Pilih Produk Reagen Gen Target"
                 v-model="reagenProduct"
                 :disabled="action!=='Start'"
                 >
                 <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listProdukReagen" />
               </vs-select>
              </vs-col>
           </vs-row>
        </vx-card>
      </div>
      <div :class="(from==='WorklistPCR'?'vx-col w-1/3 mt-2 mb-2 flex':'vx-col w-1/2 mt-2 mb-2 flex')">
        <vx-card title="Tipe BHP">
           <vs-row class="mt-4">
             <vs-col class="w-full flex" vs-justify="center" vs-align="center">
               <vs-select
                 autocomplete
                 class="w-full"
                 name="bhp"
                 placeholder="Pilih Tipe BHP"
                 v-model="bhp"
                 :disabled="action!=='Start'"
                 >
                 <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listTipeBHP" />
               </vs-select>
              </vs-col>
           </vs-row>
        </vx-card>
      </div>
    </div-->
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import patient from "@/api/patient";
import master from "@/api/master";
import test from "@/api/test";
import stock from "@/api/stock";
import moment from 'moment';

export default {
  components: {
    Datepicker
  },
  props: ['dataPatient', 'subm', 'action', 'from', 'instr', 'bhp', 'reagenProduct', 'remove', 'listTestAdd', 'listProdukReagen'],
  data() {
    return {
      test: '',
      patient: '',
      patientName: '',
      patientMR: '',
      patientBirthdate: null,
      patientAge: '',
      patientSex: '',
      visitType: '',
      priority: 1,
      ward: '',
      insurer: 57,
      physician: '',
      listPatient: [],
      listPriority: [],
      listVisitType: [],
      listWard: [],
      listInsurer: [],
      listPhysicians: [],
      listTest: [],
      listTestPatient: [],
      listTestRemove: [],
      model: {},
      inputIsVisible: false,
      validate: false,
      listTipeBHP: []
    };
  },
  methods: {
    openConfirm(groupidx, groupname, testid) {
      let obj = this.lodash.find(this.listTestPatient, o => {
        return o.name === groupname;
      });

      if (obj) {
        let objX = obj.test;
        let obj1 = this.lodash.findIndex(objX, o => {
          return o.id === testid;
        });

        objX.splice(obj1, 1);
        this.$emit('remove', {id : testid});
        /*if (objX.length==0) {
          obj.splice(0, 1);
        }*/
        //this.listTestPatient[groupidx].test = objX;
      }
    },
    openConfirm2(groupidx, groupname, childgroupname, testid) {
      let obj = this.lodash.find(this.listTestPatient, o => {
        return o.name === groupname;
      });

      if (obj) {
        let objX = this.lodash.find(obj.chidlGroup, o => {
          return o.name === childgroupname;
        });

        if (objX) {
          let obj1 = this.lodash.findIndex(objX.test, o => {
            return o.id === testid;
          });

          objX.test.splice(obj1, 1);
          this.$emit('remove', {id : testid});
        }
      }
    },
    openConfirm1(idx) {
      this.listTestAdd.splice(idx,1);
    },
    async searchPatient(event) {
      if (event.target.value.length > 2) {
			    this.model["keyword"] = event.target.value;
          const frms = await patient.listPatient(this.model);
          var tmpArr = [];
          for (var i = 0; i < frms.data.data.length; i++) {
            var tmp = {}, xdate = '', tmpAge = '';
            if (frms.data.data[i].dob) {
              xdate = new Date(frms.data.data[i].dob);

              var a = moment(xdate);
              var b = moment();

              var years = b.diff(a, 'year');
              a.add(years, 'years');

              var months = b.diff(a, 'months');

              if (Number(months) > 0) {
                tmpAge = years+ '.' + months;
              } else {
                tmpAge = years;
              }
            }

            tmp.value= frms.data.data[i].id;
            tmp.text= frms.data.data[i].patientNumber+'_'
              +frms.data.data[i].name+'_'
              +(xdate!==''?moment(xdate).format('DD-MMM-YYYY'):'')+'_'
              +(frms.data.data[i].genderId==1?'L':'P')

            tmp.name= frms.data.data[i].name;
            tmp.nomr= frms.data.data[i].patientNumber;
            tmp.age= tmpAge;
            tmp.gender= frms.data.data[i].genderId;
            tmp.bod= xdate;

            tmpArr.push(tmp);
          }
          this.listPatient = tmpArr;
      }
    },
    async getMasterData() {
      this.listPriority = JSON.parse(localStorage.getItem("listPriority"));
      this.listVisitType = JSON.parse(localStorage.getItem("listVisitType"));
      this.listInsurer= JSON.parse(localStorage.getItem("listInsurer"));
      this.listWard= JSON.parse(localStorage.getItem("listWard"));
      this.listPhysicians= JSON.parse(localStorage.getItem("listPhysicians"));
      var frms = null;
      if (this.from==='QueueClinic' || this.from==='WorklistClinic') {
        frms = JSON.parse(localStorage.getItem("listAvailableTestClinic"));
      } else {
        frms = JSON.parse(localStorage.getItem("listAvailableTestPCR"));
      }

      this.listTest= frms;
    },
    validation() {
      this.validate=true;
    },
    async getTipeBHP() {
      var frms = await stock.listUsage();
      if (frms.data.status) {
        this.listTipeBHP = frms.data.data;
      }
    }
  },
  computed: {
  },
  watch: {
    test: function(val) {
      let obj = this.lodash.find(this.listTest, o => {
        return o.parameter === val;
      });

      if (obj) {
        this.listTestAdd.push(obj);
      }
    },
    physician: function(val) {
      this.$emit('physician', val);
    },
    ward: function(val) {
      this.$emit('ward', val);
    },
    insurer: function(val) {
      this.$emit('insurer', val);
    },
    priority: function(val) {
      this.$emit('priority', val);
    },
    visitType: function(val) {
      this.$emit('patientType', val);
    },
    listTestPatient: function(val) {
      this.$emit('listTestPatient', val);
    },
    subm: function() {
      this.validation();
    },
    instr: function(val) {
      this.$emit('instr', val);
    },
    bhp: function(val) {
      this.$emit('bhp', val);
    },
    reagenProduct: function(val) {
      this.$emit('reagenProduct', val);
    }
  },
  mounted() {
  },
  created() {
    this.getTipeBHP();
    this.getMasterData();

    if (this.dataPatient) {
      this.patientName =  this.dataPatient.patient.name;
      this.patientMR = this.dataPatient.patient.patientNumber;
      var tmp = {}, xdate = '', tmpAge = '';
      if (this.dataPatient.patient.dob) {
        xdate = new Date(this.dataPatient.patient.dob);

        var a = moment(xdate);
        var b = moment();

        var years = b.diff(a, 'year');
        a.add(years, 'years');

        var months = b.diff(a, 'months');

        if (Number(months) > 0) {
          tmpAge = years+ '.' + months;
        } else {
          tmpAge = years;
        }
      }
      this.patientBirthdate = (xdate!==''?moment(xdate).format('DD-MMM-YYYY'):'');
      this.patientAge = tmpAge + ' tahun';
      this.patientSex = (this.dataPatient.patient.gender?this.dataPatient.patient.gender.name:'');
      this.priority = this.dataPatient.priority.id;
      this.visitType = this.dataPatient.patientType.id;
      this.ward = this.dataPatient.ward.name;//this.dataPatient.ward;
      this.insurer = this.dataPatient.insurer.id;
      this.physician = this.dataPatient.physician.id;
      this.listTestPatient = (this.dataPatient.wrap?this.dataPatient.wrap.measures:this.dataPatient.groupTest);
      let temp = [];
	  console.log('sss :'+JSON.stringify(this.listTestPatient));

      for (var i=0;i<this.listTestPatient.length;i++) {
        var par = this.listTestPatient[i];
        if (par.test.length>0) {
          var child = [];
          for (var j=0;j<par.test.length;j++) {
            if (par.test[j].result==null) {
              child.push(par.test[j]);
            }
          }

          par.test = child;
        }

        if (par.chidlGroup!=null && par.chidlGroup.length>0) {
          for (var j=0;j<par.chidlGroup.length;j++) {
            if (par.chidlGroup[j].test!=null && par.chidlGroup[j].test.length>0) {
              var child = [];
              for (var k=0;k<par.chidlGroup[j].test.length;k++) {
                if (par.chidlGroup[j].test[k].result==null) {
                  child.push(par.chidlGroup[j].test[k]);
                }
              }

              par.chidlGroup[j].test = child;
            }
          }
        }

        temp.push(par);
      }

      this.listTestPatient = temp;
    }
  }
};
</script>
